import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import countries from "countries-list";
import { AiOutlineClose } from "react-icons/ai";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { vatFormats } from "common/StringUtils";
import { LOCALES } from "common/constants";
import { vatPlaceholder } from "common/FunctionUtils";

const EditCustomerDialog = ({
  show,
  onClose,
  onSubmit,
  title,
  customer,
  paymentTerms = [],
  getLocation,
}) => {
  let countryCode = "";
  let updatedDefaultValue = customer;

  if (customer) {
    const characters = customer?.vatNumber?.match(/[a-zA-Z]+/g);
    const characterResult = characters ? characters.join("").slice(0, 2) : "";

    countryCode = characterResult;
    const numberResult = customer?.vatNumber?.slice(2);
    updatedDefaultValue = { ...customer, vatNumber: numberResult };
  }

  const {
    register,
    handleSubmit,
    watch,
    resetField,
    getValues,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: updatedDefaultValue,
  });

  const { t } = useTranslation();
  const globalData = useSelector((state) => state.globalData.data);
  const accountType = watch("accountType");
  const invoiceType = watch("invoiceType");

  const isVATRegistred = watch("isVATRegistred");
  const [isVatRegisterSelected, setIsVatRegisterSelected] = useState(true);
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  let newDetails = [];

  Object.keys(countries.countries).forEach((code) => {
    newDetails.push(countries.countries[code]);
  });

  const selectedPrefillCountry = watch("country");
  const [countryVal, setCountryValue] = useState(false);
  const [countryName, setCountryName] = useState("");
  const [vatNumberError, setVatNumberError] = useState("");

  Object.keys(countries.countries).forEach((code) => {
    if (countries.countries[code].name === countryName) {
      countryCode = code;
    }
    if (countryName === "USA") {
      countryCode = "US";
    }
  });

  useEffect(() => {
    if (isInitialLoad && customer) {
      const vatStatus =
        customer.isVATRegistred === "true" || customer.isVATRegistred === true;
      setIsVatRegisterSelected(vatStatus);
      setValue("isVATRegistred", vatStatus ? "true" : "false");
      setIsInitialLoad(false);
    }
  }, [customer, setValue, isInitialLoad]);
  useEffect(() => {
    if (!isInitialLoad) {
      setIsVatRegisterSelected(isVATRegistred === "true");
    }
  }, [isVATRegistred, isInitialLoad]);

  useEffect(() => {
    if (selectedPrefillCountry === "Sweden") {
      setCountryValue(true);
    }
  }, [selectedPrefillCountry]);

  useEffect(() => {
    if (accountType === 1 || accountType === "1") {
      const getSSNVal = getValues("ssn");

      if (getSSNVal) {
        resetField("ssn", { defaultValue: getSSNVal });
      } else {
        resetField("ssn", { defaultValue: "" });
      }
    } else {
      const getORGVal = getValues("orgNo");
      if (getORGVal) {
        resetField("orgNo", { defaultValue: getORGVal });
      } else {
        resetField("orgNo", { defaultValue: "" });
      }
    }
  }, [accountType, getValues, resetField]);

  const countryOptions = [
    // { value: "", label: t("Select Country") },
    { value: "Sweden", label: "Sweden" },
    { value: "USA", label: "USA" },
    { value: "Canada", label: "Canada" },
    { value: "Panama", label: "Panama" },
    // Assuming newDetails is an array of country objects with a 'name' property
    ...newDetails.map((country) => ({
      value: country.name,
      label: country.name,
    })),
  ];

  const customStyles = {
    control: (styles, { isFocused }) => ({
      ...styles,
      borderColor: errors?.country
        ? "#dc3545"
        : isFocused
          ? "none"
          : styles.borderColor,
      boxShadow: isFocused ? "0 0 0 0 gray" : styles.boxShadow,
      "&:hover": {
        borderColor: "none",
      },
      fontSize: "13px",
    }),
  };

  useEffect(() => {
    if (selectedPrefillCountry === "Sweden") {
      setCountryValue(true);
    }
  }, [selectedPrefillCountry]);

  useEffect(() => {
    if (accountType === 1 || accountType === "1") {
      const getSSNVal = getValues("ssn");

      if (getSSNVal) {
        resetField("ssn", { defaultValue: getSSNVal });
      } else {
        resetField("ssn", { defaultValue: "" });
      }
    } else {
      const getORGVal = getValues("orgNo");
      if (getORGVal) {
        resetField("orgNo", { defaultValue: getORGVal });
      } else {
        resetField("orgNo", { defaultValue: "" });
      }
    }
  }, [accountType, getValues, resetField]);

  const validateVatNumber = (countryCode, vatNumber) => {
    const format = vatFormats[countryCode];
    if (!format) {
      setVatNumberError("");
      return true;
    }
    const exampleFormat = vatFormats[countryCode]?.exampleFormat || "";
    const { regex, minLength, maxLength } = format;
    if (!regex.test(vatNumber)) {
      let errorMessage = "";
      if (vatNumber?.length < minLength || vatNumber?.length > maxLength) {
        errorMessage = `${t("Invalid VAT number format. It should be between")} ${minLength} ${t("and")} ${maxLength} ${t("digits long.")}`;
      } else {
        errorMessage = `${t("Invalid VAT number format. Expected format:")} ${exampleFormat}`;
      }
      setVatNumberError(errorMessage);
      return false;
    }
    setVatNumberError("");
    return true;
  };

  useEffect(() => {
    if (show && customer) {
      reset(updatedDefaultValue);
    }
  }, [customer, reset, show]);

  return (
    <Modal
      size="lg"
      centered
      show={show}
      onHide={onClose}
      className="editcustomermodal"
    >
      <Modal.Header>
        <Modal.Title>
          {title}

          <span className="mb-0 ml-2 title-validate">
            (
            {t(
              "Here you enter the customer information that your invoice concerns"
            )}
            )
          </span>
        </Modal.Title>
        <AiOutlineClose
          className="ml-auto cursor-pointer"
          size={24}
          onClick={onClose}
        />
      </Modal.Header>
      <form
        onSubmit={handleSubmit((values) => {
          onSubmit(values);
        })}
      >
        <Modal.Body className="edit-customer edit_custmr_cls">
          <div className="row flex-xs-column gap-0">
            {(getLocation?.pathname === "/dashboard/invoice-tool" ||
              getLocation?.pathname === "/instrumentbrada/faktura-verktyg" ||
              getLocation?.pathname === "/dashboard/economy/customers" ||
              getLocation?.pathname === "/dashboard/time-sheet" ||

              getLocation?.pathname === "/instrumentbrada/ekonomi/kunder") && (
                <div className="col">
                  <label>{t("Please select your invoice language")}</label>
                  <select
                    className={`form-control form-control-lg mb-3 ${errors.language ? "is-invalid" : ""
                      }`}
                    {...register("language", {
                      required: true,
                    })}
                  >
                    <option disabled value="">
                      {t("Select Language Type")}
                    </option>
                    <option value={LOCALES.SV_SE}>{t("Swedish")}</option>
                    <option value={LOCALES.EN_US}>{t("English")}</option>
                  </select>
                </div>
              )}

            <div className="col">
              <label>{t("How do you want your invoice?")}</label>
              <select
                className={`form-control form-control-lg mb-3 ${errors.invoiceType ? "is-invalid" : ""
                  }`}
                {...register("invoiceType", {
                  required: true,
                })}
              >
                <option value="" selected disabled>
                  {t("Select Invoice Type")}
                </option>
                <option value={1}>{t("Email (send to email address)")}</option>
                <option value={2}>{t("E-invoice (send as electronic invoice)")}</option>
                <option value={3}>{t("Post (60 SEK)")}</option>
              </select>
            </div>
          </div>
          {(invoiceType === "2" || invoiceType === 2) && (
            <>
              <div className="row flex-xs-column gap-0">
                <div className="col col-lg-4 col-md-6 col-sm-12">
                  <label>{t("Our electronic reference")}</label>
                  <input
                    type="text"
                    className={`form-control form-control-lg mb-3 ${errors.ourElectronicReference ? "is-invalid" : ""
                      }`}
                    placeholder={t("Our electronic reference")}
                    defaultValue="7230020"
                    readOnly
                    {...register("ourElectronicReference", {
                      required: false,
                    })}
                  />
                </div>
                <div className="col col-lg-4 col-md-6 col-sm-12">
                  <label>{t("Your electronic reference")}</label>
                  <input
                    type="text"
                    className={`form-control form-control-lg mb-3 ${errors.yourElectronicReference ? "is-invalid" : ""
                      }`}
                    placeholder={t("Your electronic reference")}
                    {...register("yourElectronicReference", {
                      required: true,
                    })}
                  />
                </div>
                <div className="col col-lg-4 col-md-12 col-sm-12">
                  <label>{t("GLN / Peppol ID")}</label>
                  <input
                    type="text"
                    className={`form-control form-control-lg mb-3 ${errors.globalLocationNumber ? "is-invalid" : ""
                    }`}
                    placeholder={t("GLN / Peppol ID")}
					          onInput={(e) => {
                      e.target.value = e.target.value.replace(/[^0-9]/g, '').slice(0, 18);
                    }} 	
                    {...register("globalLocationNumber", {
                      required: true,
                      maxLength: 18,
                      minLength: 13
                    })}
                  />
                </div>
              </div>
              <div className="row flex-xs-column gap-0">
                <div className="col">
                  <label>{t("Extra field 1 e-invoice (optional)")}</label>
                  <input
                    type="text"
                    className={`form-control form-control-lg mb-3 ${errors.extraField1 ? "is-invalid" : ""
                      }`}
                    placeholder={t("Extra field 1 e-invoice")}
                    {...register("extraField1")}
                  />
                </div>
                <div className="col col-md-6 col-sm-12">
                  <label>{t("Extra field 2 e-invoice (optional)")}</label>
                  <input
                    type="text"
                    className={`form-control form-control-lg mb-3 ${errors.extraField2 ? "is-invalid" : ""
                      }`}
                    placeholder={t("Extra field 2 e-invoice")}
                    {...register("extraField2")}
                  />
                </div>
              </div>
            </>
          )}

          <div className="row flex-xs-column gap-0">
            <div className="col">
              <label>{t("Business Type")}</label>
              <select
                className={`form-control form-control-lg mb-3 ${errors.accountType ? "is-invalid" : ""
                  }`}
                {...register("accountType", {
                  required: true,
                })}
              >
                <option value="">{t("Select Account Type")}</option>

                {globalData &&
                  globalData?.customerAccountType?.map((accountType) => (
                    <option
                      className="account_type_select"
                      key={accountType.key}
                      value={accountType.value}
                    >
                      {t(accountType.text)}
                    </option>
                  ))}
              </select>
            </div>
            <div className="col col-md-6 col-sm-12">
              <label>{t("Name")}</label>
              <input
                type="text"
                className={`form-control form-control-lg mb-3 ${errors.name ? "is-invalid" : ""
                  }`}
                placeholder={t("Name")}
                {...register("name", {
                  required: true,
                })}
              />
            </div>
          </div>
          <div className="row flex-xs-column gap-0">
            {
              // !customer &&
              accountType === "1" || accountType === 1 ? (
                <div className="col">
                  <label>{t("SSN No.")}</label>
                  <input
                    type="text"
                    className={`form-control form-control-lg mb-3 ${errors.ssn ? "is-invalid" : ""
                      }`}
                    placeholder="YYYYMMDD0000"
                    {...register("ssn", {
                      required: true,
                      minLength: 8,
                    })}
                  />
                  <span>
                    {errors.ssn && (
                      <p className="text-danger">
                        {t("SSN number should be greater then 8 digit")}
                      </p>
                    )}
                  </span>
                </div>
              ) : (
                <div className="col">
                  <label>
                    {t("Org No")}{" "}
                    <span
                      className="mb-0 ml-1 title-validate"
                      style={{ fontSize: "11px" }}
                    >
                      ({t("Only numbers are allowed")})
                    </span>
                  </label>
                  <input
                    type="text"
                    onKeyDown={(e) => {
                      // Allow only numbers, decimal point, and specific control keys
                      if (
                        !/[\d.]/.test(e.key) &&
                        ![
                          "Backspace",
                          "ArrowLeft",
                          "ArrowRight",
                          "Tab",
                          "Delete",
                          "Control",
                          "v",
                          "Meta",
                        ].includes(e.key) &&
                        !(e.ctrlKey || e.metaKey)
                      ) {
                        e.preventDefault();
                      }
                    }}
                    className={`form-control form-control-lg mb-3 ${errors.orgNo ? "is-invalid" : ""
                      }`}
                    placeholder={t("Org No")}
                    {...register("orgNo", {
                      required: true,
                    })}
                  />
                </div>
              )
            }
            <div className="col col-md-6 col-sm-12">
              <label>{t("Phone Number")}</label>
              <input
                className={`form-control form-control-lg mb-3 ${errors.phoneNumber ? "is-invalid" : ""
                  }`}
                placeholder={t("Phone Number")}
                onKeyDown={(e) => {
                  const inputValue = e.key;
                  const allowedCharacters =
                    /^[0-9!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]$/;

                  if (
                    inputValue !== "Backspace" &&
                    !allowedCharacters.test(inputValue) &&
                    ![
                      "Backspace",
                      "ArrowLeft",
                      "ArrowRight",
                      "Tab",
                      "Delete",
                      "Control",
                      "v",
                      "Meta",
                    ].includes(inputValue)
                  ) {
                    e.preventDefault();
                  }
                }}
                {...register("phoneNumber", {
                  required: true,
                })}
              />
            </div>
          </div>
          <div className="row flex-xs-column gap-0">
            <div className="col col-md-6 col-sm-12">
              <label>
                {t("Reference")}
                <span className="ml-1" style={{ fontSize: "11px" }}>
                  (
                  {t(
                    "Here, enter the name of the person who will approve your invoice or an order number."
                  )}
                  )
                </span>
              </label>
              <input
                type="text"
                className={`form-control form-control-lg mb-3 ${errors.reference ? "is-invalid" : ""
                  }`}
                placeholder={t("Reference")}
                {...register("reference", {
                })}
              />
            </div>

            <div className="col col-md-6 col-sm-12">
              <label>
                {t("Email")}
                <span className="ml-1" style={{ fontSize: "11px" }}>
                  (
                  {t(
                    "where your invoice will be sent. A copy is always sent to your own email"
                  )}
                  )
                </span>
              </label>
              <input
                type="email"
                className={`form-control form-control-lg mb-3 ${errors.email ? "is-invalid" : ""
                  }`}
                placeholder={t("Email")}
                {...register("email", {
                  required: invoiceType !== "3" && true,
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: t("Invalid email address"),
                  },
                })}
              />
            </div>
          </div>
          <div className="row flex-xs-column gap-0">
            <div className="col col-md-6 col-sm-12">
              <label>{t("Address")}</label>
              <input
                type="text"
                className={`form-control form-control-lg mb-3 ${errors.address ? "is-invalid" : ""
                  }`}
                placeholder={t("Address")}
                {...register("address", {
                  required: true,
                })}
              />
            </div>

            {accountType !== "1" && accountType !== 1 && (
              <div className="col col-md-6 col-sm-12">
                <label>{t("Address 2 (optional)")}</label>
                <input
                  type="text"
                  className={`form-control form-control-lg mb-3`}
                  placeholder={t("Address 2")}
                  {...register("address2")}
                />
              </div>
            )}

            <div
              className={
                accountType === "1" || accountType === 1
                  ? "col col-md-6 col-sm-12"
                  : "col col-md-12 col-sm-12"
              }
            >
              <label>
                {t("Country")}
                <span className="ml-1" style={{ fontSize: "11px" }}>
                  (
                  {t(
                    "When you select a country other than Sweden, your invoice will automatically be in English."
                  )}
                  )
                </span>
              </label>

              <Select
                placeholder={t("Select Country")}
                styles={customStyles}
                defaultValue={countryOptions?.find(
                  (item) => item.label === customer?.country
                )}
                options={countryOptions}
                // required={errors.country && !countryName}
                {...register("country", {
                  required: true,
                })}
                onChange={(selectedOption) => {
                  const selectedCountry = selectedOption.value;
                  selectedCountry === "Sweden"
                    ? setCountryValue(true)
                    : setCountryValue(false);
                  setCountryName(selectedOption.value);
                  resetField("vatNumber", { defaultValue: "" });
                  if (!selectedCountry) {
                    setValue("country", "");
                  } else {
                    setValue("country", selectedOption.value);
                  }
                  setVatNumberError("");
                }}
              />
            </div>
          </div>

          <div className="row flex-xs-column gap-0">
            {accountType !== "1" && accountType !== 1 && (
              <div className="col">
                <label htmlFor="have_vatnumber">
                  {t("Does your customer have a VAT registration number?")}
                </label>
                <select
                  id="have_vatnumber"
                  className="form-control form-control-md mb-3"
                  {...register("isVATRegistred", { required: true })}
                  defaultValue={isVatRegisterSelected ? "true" : "false"}
                  onChange={(e) => {
                    const value = e.target.value === "true";
                    setIsVatRegisterSelected(value); // Update the state based on user selection
                    setValue("isVATRegistred", e.target.value); // Update the form value for isVATRegistred
                  }}
                >
                  <option value="true">{t("Yes")}</option>
                  <option value="false">{t("No")}</option>
                </select>
              </div>
            )}

            {accountType !== "1" &&
              accountType !== 1 &&
              isVatRegisterSelected && (
                <div className="col col-md-6 col-sm-12">
                  <label>
                    {t("Vat. Number")}
                    <span className="ml-1" style={{ fontSize: "11px" }}>
                      ({t("We automatically add the country code.")})
                    </span>
                  </label>

                  <div className="select-box">
                    <div className="arrow-downcheck">
                      <p> {countryCode}</p>
                    </div>
                    <div className="input-box">
                      <input
                        min={4}
                        type="text"
                        placeholder={t(vatPlaceholder(countryCode))}                       
                        className={`form-control form-control-lg mb-3 ${errors.vatNumber ? "is-invalid" : ""
                          }`}
                        onInput={(e) => {
                          const allowedCharacters =
                            vatFormats[countryCode]?.allowedCharacters ||
                            /^[A-Za-z0-9]*$/;
                          e.target.value = e.target.value.replace(
                            /[^A-Za-z0-9]/g,
                            ""
                          );
                          const maxLength =
                            vatFormats[countryCode]?.maxLength || 18;
                          if (e.target.value.length > maxLength) {
                            e.target.value = e.target.value.slice(0, maxLength);
                          }
                          Object.keys(countries.countries).forEach((code) => {
                            if (
                              countries.countries[code].name ===
                              selectedPrefillCountry
                            ) {
                              countryCode = code;
                            }
                          });
                        }}
                        onKeyDown={(e) => {
                          const allowedCharacters =
                            vatFormats[countryCode]?.allowedCharacters ||
                            /^[A-Za-z0-9]*$/;
                          if (
                            allowedCharacters.test(e.key) ||
                            [
                              "Backspace",
                              "Delete",
                              "ArrowLeft",
                              "ArrowRight",
                              "Tab",
                            ].includes(e.key)
                          ) {
                            return true;
                          } else {
                            e.preventDefault();
                            return false;
                          }
                        }}
                        {...register("vatNumber", {
                          required:
                            countryVal === false &&
                            accountType !== "1" &&
                            accountType !== 1,
                          validate: (value) =>
                            validateVatNumber(countryCode, value),
                        })}
                      />
                    </div>
                  </div>
                  {vatNumberError !== "" && (
                    <span className="vatNumberError">{vatNumberError}</span>
                  )}
                </div>
              )}

            <div
              className={
                accountType === "1" ||
                  accountType === 1 ||
                  isVatRegisterSelected
                  ? "col col-md-12 col-sm-12"
                  : "col col-md-6 col-sm-12"
              }
            >
              <label>{t("City")}</label>
              <input
                type="text"
                className={`form-control form-control-lg mb-3 ${errors.city ? "is-invalid" : ""
                  }`}
                placeholder={t("City")}
                {...register("city", {
                  required: true,
                })}
              />
            </div>
          </div>
          <div className="row flex-xs-column gap-0">
            <div className="col col-md-6 col-sm-12">
              <label>{t("Zip Code")}</label>
              <input
                type="text"
                className={`form-control form-control-lg mb-3 ${errors.zipCode ? "is-invalid" : ""
                  }`}
                placeholder={t("Zip Code")}
                {...register("zipCode", {
                  required: true,
                })}
                onInput={(e) => {
                  const maxLength = 9;
                  e.target.value = e.target.value.replace(/[^a-zA-Z0-9]/g, "");
                  if (e.target.value.length > maxLength) {
                    e.target.value = e.target.value.slice(0, maxLength);
                  }
                }}
              />
            </div>
            {invoiceType === "3" && (
              <div className="col col-md-6 col-sm-12">
                <label>{t("C/O")}</label>
                <input
                  type="text"
                  className={`form-control form-control-lg mb-3 ${errors.careOf ? "is-invalid" : ""
                    }`}
                  placeholder={t("C/O")}
                  {...register("co")}
                />
              </div>
            )}
            <div className="col">
              <label>
                {t("Payment terms")}
                <span className="ml-1" style={{ fontSize: "11px" }}>
                  (
                  {t(
                    "specify 30 days unless you and the customer have agreed otherwise"
                  )}
                  )
                </span>
              </label>
              <select
                t
                ype="text"
                // menuIsOpen={true}
                className={`form-control form-control-lg mb-3 ${errors.paymentTerm ? "is-invalid" : ""
                  }`}
                {...register("paymentTerm", {
                  required: true,
                })}
              >
                <option value="" selected disabled>
                  {t("Payment Term")}
                </option>
                {paymentTerms.map((paymentTerm) => (
                  <option key={paymentTerm.id} value={paymentTerm.globalValue}>
                    {paymentTerm.globalValue} {t("days")}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="outline_btn_new"
            variant="secondary"
            onClick={onClose}
          >
            {t("Close")}
          </button>
          <Button
            className="text-light save_add_customer new_theme_btn"
            type="submit"
          >
            {t("Save")}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default EditCustomerDialog;
